import { Card, Heading } from './SubSelectCard.styles';
import type { SubSelectCardProps } from './SubSelectCard.types';

export function SubSelectCard({ heading, children, className }: SubSelectCardProps) {
  return (
    <Card className={className}>
      {heading && <Heading>{heading}</Heading>}
      {children}
    </Card>
  );
}
